var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("UiButtonMessage", {
        attrs: { label: "add gray" },
        on: { click: _vm.showModal },
      }),
      _vm.modalShown
        ? _c("ActivityFormModal", {
            attrs: {
              showProject: true,
              contractorId: _vm.contractorId,
              currentUserRole: _vm.currentUser.role,
              companyId: _vm.companyId,
              currentUserId: _vm.currentUser.id,
            },
            on: {
              activityAdded: _vm.onActivityAdded,
              close: function ($event) {
                _vm.modalShown = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }